import React, { useEffect, useState } from "react";
import styles from "./gfquotebtn.module.css";
import { Modal } from "react-responsive-modal";
import 'react-responsive-modal/styles.css';
import Tabs from '../Tabs/Tabs';
import '../Tabs/tabs.css';
import SaveForLater from "../SaveForLater/Saveforlater.js";



const QuoteButton = () => {
    const [loaded, setLoaded] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [setting, setSetting] = useState(false);
    const [planUpgradable, setplanUpgradable] = useState(false);

    const handleAppSetting = async () => {
        const requestOptions = {
            method: "POST",
            body: JSON.stringify({
                shop_domain: window.Shopify.shop
            })
        };
        const res = await fetch(
            `${process.env.REACT_APP_API_URL}` + "appSetting",
            requestOptions
        );
        const app_setting = await res.json();
        setSetting(app_setting.data);
    };

    useEffect(() => {
        handleAppSetting();
        wishlistCount();
    }, []);
    // let handlePush = async e => {
    //     window.location.href =
    //         "https://" + window.Shopify.shop + "/pages/gemfind-my-wishlist";
    // };

    const wishlistCount = async data => {
        const requestOptions = {
            method: "POST",
            body: JSON.stringify({
                shop_domain: window.Shopify.shop,
                customer_id:
                    window.meta.page.customerId != undefined
                        ? window.meta.page.customerId
                        : null,
            })
        };
        const res = await fetch(
            `${process.env.REACT_APP_API_URL}` + "wishlistCount",
            requestOptions
        );
        const set_count = await res.json();
        if (set_count) {
            if (set_count.data.wishlist_plan_upgradable) {
                setplanUpgradable(set_count.data.wishlist_plan_upgradable);
                // console.log(set_count)
            }
        }

    };

    let handlePush = () => {
        setIsOpen(true);
    };

    return (
        <div>
            {setting.save_for_later_option !== "false" ?
                <SaveForLater />
                : ''}
            <div className={styles.gf_fab_container}>
                <div className={styles.gf_fab}>
                    {/* <a onClick={handlePush} id={"gf_rotate_button"}>
                        My Wishlist
                    </a> */}
                    <button style={{opacity:1}} onClick={handlePush} id={"gf_rotate_button"}>
                        My Wishlist
                    </button>
                    {planUpgradable ?
                        <Modal
                            open={isOpen}
                            onClose={() => setIsOpen(false)}
                            center
                            classNames={{
                                overlay: "popup_Overlay",
                                modal: "popup-form-extra-small plan--modal"
                            }}
                        >
                            <p>Wishlist limit is over, Please contact Us for more information.</p>
                        </Modal>
                        :
                        <Modal
                            open={isOpen}
                            onClose={() => setIsOpen(false)}
                            center
                            classNames={{
                                overlay: "popup_Overlay",
                                modal: "popup-form-extra-small wishlist--modal"
                            }}
                        >
                            <Tabs />
                        </Modal>
                    }

                </div>
            </div>
        </div>
    );
};

export default QuoteButton;
